import { PropsWithChildren, createContext, useContext, useMemo } from 'react';

import styles from './context.module.scss';
import { CoreContextProps } from './context.types';

const CoreContext = createContext<CoreContextProps | undefined>(undefined);

export const CoreProvider = ({
  brand,
  children,
}: PropsWithChildren<CoreContextProps>) => {
  const context = useMemo(() => ({ brand }), [brand]);

  return (
    <CoreContext.Provider value={context}>
      <div data-brand-context={brand} className={styles['core-context']}>
        {children}
      </div>
    </CoreContext.Provider>
  );
};

export function useCoreContext() {
  return useContext(CoreContext);
}
